import {css} from '@emotion/react'
import {Tree as AntdTree} from 'antd'
import {decodeBr} from './utils.mjs'

export const isTree = ({children, treeName}) => ! (
    void 0 === children ||
    void 0 === treeName
)

const cssCaption = css({
    color: 'rgba(0, 0, 0, 0.45)',
    padding: '0.75em 0 0.3em 0',
})

const cssTree = css({
    overflowY: 'hidden',

    '.ant-tree-node-content-wrapper': {
        userSelect: 'auto',
    },
})

const buildTreeData = ({children = [], name, props = []}) => ({
    children: [
        ...props
            .filter(
                ({name, show, value}) => show && (name || value)
            )
            .map(
                ({name, value}) => ({
                    title: name ?
                        `${name}: ${decodeBr(value)}`
                        :
                        decodeBr(value)
                })
            ),

        ...children.map(buildTreeData)
    ],

    title: name,
})

export const Tree = ({data, ...props}) => {
    const {treeName, children = []} = data
    const treeData = children.map(buildTreeData)

    return (
        <div
            css={cssTree}
            {...props}
        >
            <div css={cssCaption}>{treeName}</div>

            <AntdTree
                defaultExpandAll
                selectable={false}
                showLine
                treeData={treeData}
            />
        </div>
    )
}
